<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      Path for the existing userid, or where it will be stored if user needs to be created:
      <input type="text" [(ngModel)]="seConfiguration.userIdTarget" />
    </label>
  </div>
</div>

<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      organizationId:
      <input type="text" [(ngModel)]="seConfiguration.organizationId" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      firstName:
      <input type="text" [(ngModel)]="seConfiguration.firstName" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      middleInitial:
      <input type="text" [(ngModel)]="seConfiguration.middleInitial" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      lastName:
      <input type="text" [(ngModel)]="seConfiguration.lastName" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      Entity or Organization Name:
      <input type="text" [(ngModel)]="seConfiguration.entityOrOrganizationName" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      Is an Entity or Organization:
      <input type="text" [(ngModel)]="seConfiguration.isEntityOrOrganization" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      suffix:
      <input type="text" [(ngModel)]="seConfiguration.suffix" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      fullLegalName:
      <input type="text" [(ngModel)]="seConfiguration.fullLegalName" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      emailAddress:
      <input type="text" [(ngModel)]="seConfiguration.emailAddress" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      userName:
      <input type="text" [(ngModel)]="seConfiguration.userName" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      primaryPhone:
      <input type="text" [(ngModel)]="seConfiguration.primaryPhone" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      secondaryPhone:
      <input type="text" [(ngModel)]="seConfiguration.secondaryPhone" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      fax:
      <input type="text" [(ngModel)]="seConfiguration.fax" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      street:
      <input type="text" [(ngModel)]="seConfiguration.street" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      suite:
      <input type="text" [(ngModel)]="seConfiguration.suite" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      poBox:
      <input type="text" [(ngModel)]="seConfiguration.poBox" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      city:
      <input type="text" [(ngModel)]="seConfiguration.city" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      stateCode:
      <input type="text" [(ngModel)]="seConfiguration.stateCode" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      zipCode:
      <input type="text" [(ngModel)]="seConfiguration.zipCode" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      Internal Contact:
      <input type="text" [(ngModel)]="seConfiguration.internalContact" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      Is a User:
      <input type="text" [(ngModel)]="seConfiguration.isUserTarget" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      Agent Type:
      <input type="text" [(ngModel)]="seConfiguration.agentType" />
    </label>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      Can Login (Is Enabled):
      <input type="text" [(ngModel)]="seConfiguration.canLogin" />
    </label>
  </div>
</div>
<div class="cell small-12">
  Select Group Contact will be assigned to:
</div>
<div class="cell small-12">
  <select [(ngModel)]="seConfiguration.groupIdToAssignUserTo">
    @for (group of availableGroups; track group) {
      <option [value]="group.id">{{group.displayName}}</option>
    }
  </select>
</div>